import React from 'react';
import { motion } from 'framer-motion';
import { staggerContainer, staggerItem } from '../../utils/animations';
import Button from '../../Components/common/Button';
import GradientText from '../../Components/common/GradientText';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-dark-bg overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark-bg via-primary-blue/10 to-primary-purple/10"></div>

      {/* Animated Circles */}
      <motion.div
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.5, 0.3],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-gradient-primary opacity-20 blur-3xl"
      />
      <motion.div
        animate={{
          scale: [1.2, 1, 1.2],
          opacity: [0.2, 0.4, 0.2],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        className="absolute bottom-1/4 left-1/4 w-96 h-96 rounded-full bg-accent-cyan opacity-20 blur-3xl"
      />

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <motion.div
          variants={staggerContainer}
          initial="initial"
          animate="animate"
          className="text-center max-w-4xl mx-auto"
        >
          <motion.h1
            variants={staggerItem}
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight"
          >
            <GradientText as="span">Innovative IT Solutions</GradientText>
            <br />
            for Modern Businesses
          </motion.h1>

          <motion.p
            variants={staggerItem}
            className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto"
          >
            Web Development • Mobile Apps • AI Integration • Digital Consulting
          </motion.p>

          <motion.p
            variants={staggerItem}
            className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto"
          >
            Transform your business with cutting-edge technology solutions. From custom web applications to AI-powered systems, we deliver excellence.
          </motion.p>

          <motion.div
            variants={staggerItem}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Button
              variant="primary"
              size="lg"
              onClick={() => (window.location.href = '/services')}
            >
              Our Services
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => (window.location.href = '/contact')}
            >
              Get a Quote
            </Button>
          </motion.div>

          {/* Scroll Indicator */}
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="mt-16"
          >
            <p className="text-gray-400 text-sm mb-2">Scroll to explore</p>
            <div className="w-6 h-10 border-2 border-gray-400 rounded-full mx-auto flex justify-center">
              <motion.div
                animate={{ y: [0, 12, 0] }}
                transition={{ duration: 1.5, repeat: Infinity }}
                className="w-1.5 h-1.5 bg-gradient-primary rounded-full mt-2"
              />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
